/**
 * SearchField
 * @module components/SearchField
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './SearchField.scss';
import Icon from 'components/Icon';
import Router from 'next/router';
import { I18nContext } from 'context/i18n.context';

/** Class representing the component. */
class SearchField extends Component {

	static contextType = I18nContext;

	constructor(props) {
		super(props);

		this.state = {
			value: ''
		};
	}

	
	/**
	 * Handles submitting of form
	 */
	onSubmit (e, currentLanguage) {
		e.preventDefault();

		const searchAsPreview = Router.asPath.indexOf('_preview') !== -1 ? '_preview' : null;
		const pathname = currentLanguage === 'en' ? `/search` : `/${currentLanguage}/search`;
		let query = { query: this.state.value, language: currentLanguage };

		if (searchAsPreview) {
			query.preview = searchAsPreview;
		}

		Router.push({ pathname, query });
	}


	/**
	 * The render method
	 */
	render () {
		const { t, currentLanguage } = this.context;
		const { id } = this.props;

		return (
			<form className={style.searchField} onSubmit={(e) => this.onSubmit(e, currentLanguage)}>
				<label htmlFor={id || 'search-header'}>
					<span className="is-visuallyhidden">{t('searchForSomething')}</span>
					<input id={id || 'search-header'} type="text" placeholder={t('search')} value={this.state.value} onChange={(e) => this.setState({ value: e.target.value})} />
					<button type="submit" className={style.searchIcon} title={t('performSearch')}>
						<Icon icon="icon-search" />
					</button>
				</label>
			</form>
		);
	}
}


/** Prop types **/
SearchField.propTypes = {
	id: PropTypes.string
};

export default SearchField;
